export default __webpack_public_path__ + "static/media/pop.a521b9e9.png";